var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.865,
    height: 24,
    viewBox: "0 0 20.865 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Timer",
    d: "M367-437.359a10.36,10.36,0,0,1,10.36-10.36,10.333,10.333,0,0,1,7.625,3.347l.315-.237.98-.738a.5.5,0,0,1,.7.1l.784,1.039a.5.5,0,0,1-.1.7l-.045.034-.015.012-.919.693-.338.255a10.312,10.312,0,0,1,1.373,5.156A10.36,10.36,0,0,1,377.36-427,10.36,10.36,0,0,1,367-437.359Zm1.957,0a8.413,8.413,0,0,0,8.4,8.4,8.413,8.413,0,0,0,8.4-8.4,8.413,8.413,0,0,0-8.4-8.4A8.413,8.413,0,0,0,368.957-437.359Zm7.424,0v-5.756a.979.979,0,0,1,.979-.978.979.979,0,0,1,.978.978v5.756a.979.979,0,0,1-.978.978A.979.979,0,0,1,376.381-437.359Zm-2.474-11.684a.978.978,0,0,1-.978-.978.978.978,0,0,1,.978-.978h6.907a.979.979,0,0,1,.978.978.978.978,0,0,1-.978.978Z",
    transform: "translate(-367 451)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerBlack);
export default __webpack_public_path__ + "static/media/TimerBlack.4f357d323ffc7d4ba84b61c0904ca144.svg";
export { ForwardRef as ReactComponent };